export default "__VITE_ASSET__BceFZ7gZ__"